import React from 'react';
import { renderFromComponentMap } from '@goodrx/x-core';
import { HDHomePressLinks as HDHomePressLinksDSM } from './components';
export const Placeholder = props => {
  const {
    type
  } = props;
  const componentMap = {
    default: () => /*#__PURE__*/React.createElement("div", null),
    hd_hp_press: () => /*#__PURE__*/React.createElement(HDHomePressLinksDSM, props)
  };
  return renderFromComponentMap(componentMap, type || 'default');
};